import { useEffect, useState } from "react";
import { Card, CardBody } from "../../components/card/card.jsx";
import ColorApp from "../../components/color/color.js";
import Chart from "react-apexcharts";
import TrainingChart1 from "../../components/chart/trainingChart1Options.jsx";
import DonatOptions from "../../components/chart/DonatOptions.jsx";
import ChatrtLineOption from "../../components/chart/chartLineOption.jsx";
const mounth = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function KpiMain({ dataKpi }) {
  const [reload, setReload] = useState(1);
  const yearlyAch = (d) => {
    const actual = d * 100;
    return [100 - actual, actual];
  };
  const trainingChart1 = (d) => {};
  useEffect(() => {
    document.addEventListener("theme-reload", () => {
      setReload((a) => a + 1);
    });
  }, []);
  return (
    <>
      <div>
        {dataKpi.main.map((kpiMain, index) => (
          <div key={index}>
            <div className="col-xl-12 mb-3">
              <h5>{kpiMain.item}</h5>
              <div className="row">
                <div className="col-lg-4">
                  <Chart
                    type="bar"
                    key={reload}
                    height={300}
                    options={TrainingChart1({ label: mounth })}
                    series={[
                      {
                        name: "Target",
                        data: kpiMain?.value?.map((i) => i.target) ?? [],
                      },
                      {
                        name: "Actual",
                        data: kpiMain?.value?.map((i) => i.actual) ?? [],
                      },
                    ]}
                  />
                </div>
                <div className="col-lg-4">
                  <Chart
                    type="line"
                    key={reload}
                    height={300}
                    options={ChatrtLineOption({ label: mounth })}
                    series={[
                      {
                        name: "Running Target",
                        data: kpiMain?.value?.map((i) => i.runningTarget) ?? [],
                      },
                      {
                        name: "Running Actual",
                        data: kpiMain?.value?.map((i) => i.runningActual) ?? [],
                      },
                    ]}
                  />
                </div>
                <div className="col-lg-4">
                  <div className="row">
                    <div className="col-lg-12 mb-3 mb-lg-0">
                      <div className="d-flex">
                        <div className="w-70px pt-3">
                          <Chart key={reload} type="donut" height={70} options={DonatOptions()} series={yearlyAch(kpiMain.yearly.achievement)} />
                        </div>
                        <div className="ps-3 flex-1">
                          <div className="fs-10px fw-bold text-inverse text-opacity-50 mb-1">{kpiMain.item}</div>
                          <div className="mb-2 fs-5 text-truncate">{`${kpiMain.yearly.actual}/${kpiMain.yearly.target}`}</div>
                          <div className="progress h-3px bg-inverse-transparent-2 mb-1">
                            <div className="progress-bar bg-theme" style={{ width: kpiMain.yearly.achievement * 100 }}></div>
                          </div>
                          {/* <div className="fs-11px text-inverse text-opacity-50 mb-4 text-truncate">{kpiAll.resume.updated}</div> */}
                          {/* {kpiAll.resume.info
                            ? kpiAll.resume.info.map((info, index2) => (
                                <div className="d-flex align-items-center small" key={index2}>
                                  <i className="bi bi-circle-fill fs-6px me-2 "></i>
                                  <div className="flex-1">{info.index}</div>
                                  <div>{info.value}</div>
                                </div>
                              ))
                            : ""} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        ))}
      </div>
    </>
  );
}
export default KpiMain;
